import React, { useState } from 'react';
import GlassCard from '../../../shared/components/card/GlassCard';
import ChangeEmailForm from '../components/ChangeEmailForm';
import '../../../styles/LoginForm.css'; // Reutilizamos los mismos estilos

const ChangeEmailPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ 
    newEmail: '', 
    confirmEmail: '' 
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [shake, setShake] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Usar función en lugar de valor directo
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value
    }));
    
    console.log("change", name, value);
    if (error) setError('');
    if (success) setSuccess('');
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateEmails = () => {
    if (!validateEmail(formData.newEmail)) {
      return 'Ingresa un correo electrónico válido.';
    }
    if (formData.newEmail !== formData.confirmEmail) {
      return 'Los correos electrónicos no coinciden.';
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const validationError = validateEmails();
    if (validationError) {
      setError(validationError);
      setShake(true);
      setTimeout(() => setShake(false), 2000);
      return;
    }

    setIsLoading(true);
    setError('');
    setSuccess('');

    try {
      // Aquí llamas a tu API para cambiar el email
      // await changeEmailAPI(formData.newEmail);
      
      // Simulación de éxito (reemplazar con llamada real)
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setSuccess('Correo electrónico actualizado correctamente.');
      setFormData({ newEmail: '', confirmEmail: '' });
      
    } catch (err) {
      setError(getErrorMessage(err));
      setShake(true);
      setTimeout(() => setShake(false), 2000);
    } finally {
      setIsLoading(false);
    }
  };

  const getErrorMessage = (err) => {
    const statusCode = err?.response?.status;
    const serverMessage = err?.response?.data?.message;
    const errorCode = err?.code;

    if (serverMessage) return serverMessage;

    switch (statusCode) {
      case 400:
        return 'Datos inválidos. Verifica el correo electrónico.';
      case 401:
        return 'Sesión expirada. Inicia sesión nuevamente.';
      case 403:
        return 'No tienes permisos para realizar esta acción.';
      case 409:
        return 'El nuevo correo ya está registrado o es igual al anterior.';
      case 422:
        return 'El formato del correo no es válido.';
      case 500:
        return 'Error del servidor. Intenta más tarde.';
      default:
        break;
    }

    switch (errorCode) {
      case 'ECONNABORTED':
      case 'TIMEOUT':
        return 'Tiempo de espera agotado. Revisa tu conexión.';
      case 'NETWORK_ERROR':
      case 'ERR_NETWORK':
        return 'Sin conexión a internet.';
      default:
        break;
    }

    return 'Error al cambiar el correo electrónico. Intenta de nuevo.';
  };

  return (
    <div className="minimal-container">
      <GlassCard>
        <ChangeEmailForm
          formData={formData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          isLoading={isLoading}
          error={error}
          success={success}
          shake={shake}
        />
      </GlassCard>
    </div>
  );
};

export default ChangeEmailPage;